<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in visibleItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref, computed } from '@vue/composition-api'
import checkPermissions from '@core/libs/permission'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    provide('openGroups', ref([]))

    // A `{ header: '...' }` entry (e.g. "Hygiene Testing", "Marketplace",
    // "Intelligence") always rendered before this, even when every nav item
    // under it was hidden by checkPermissions() (module disabled for the
    // company, or role-gated) — VerticalNavMenuHeader has no way to see its
    // sibling items, so it can only check permissions on itself, and a bare
    // header object carries no moduleSlug/roles of its own. Header visibility
    // has to be resolved here instead, where the full flat list is available:
    // a header is kept only if at least one item between it and the next
    // header would itself pass checkPermissions (the same check
    // VerticalNavMenuLink/Group already use to decide their own v-if).
    const visibleItems = computed(() => {
      return props.items.filter((item, index) => {
        if (!item.header) return true

        const nextHeaderIndex = props.items.findIndex(
          (other, otherIndex) => otherIndex > index && other.header
        )
        const sectionEnd = nextHeaderIndex === -1 ? props.items.length : nextHeaderIndex
        const sectionItems = props.items.slice(index + 1, sectionEnd)

        return sectionItems.some((sectionItem) => checkPermissions(sectionItem))
      })
    })

    return {
      visibleItems,
      resolveNavItemComponent,
    }
  },
}
</script>
